import { render, staticRenderFns } from "./DobDisplay.vue?vue&type=template&id=4454562c"
import script from "./DobDisplay.vue?vue&type=script&lang=js"
export * from "./DobDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports